import * as types from './mutations-types'

const mutations = {
    [types.SET_USERDATA](state, userdata){
        state.userdata = userdata
    },
    [types.SET_LOADING](state,loading){
        state.loading = loading
    },
    [types.SET_TAG](state, tag) {
        state.tag = tag
    },
	[types.SET_TAGSTATUS](state, tagstatus) {
	    state.tagstatus = tagstatus
	},
    [types.SET_TOGGLEFLAG](state, toggleflag) {
        state.toggleflag = toggleflag
    },
	[types.SET_STATECHANGE](state, statechange) {
	    state.statechange = statechange
	}
}

export default mutations